export const imperative = [
  {
    id: 'imperativ-du',
    category: 'imperativ',
    level: 'A2',
    title: 'Imperativ für "du" (Urdhëron Thelbesor një mik / fëmijë)',
    detailedContent: `
      <section>
        <p>Gjermanishtja e ndarën Rregullt Urdhërin. Ata thelbojn tre tipe thelb njerëzve <b>Du (Miq e familjar nj numr), Ihr (dy e më shume miq e thelb femijsh) Thelb Sie (Rrespekt autoritet thelbt).</b></p>
        
        <h3>1. Formulimi për Veten Dytë ("Ti")</h3>
        <p>Të gjitha foljet thelb gjermane formon një Urdhër direkt duke ja Tunduar thelbumes thelbit Prësensit ("du kach-st, du spiel-st") Rrënjën personale dhe e mbajm vetem thelbi. Dmth: Ndërpresh <b>-ST</b>-n THE Thelbin <b>"du"</b> hidh te dy.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Praktik thelbesisht DU:</strong> Zgjedho veten 2the du (du spielst). HIDHE "du" tutje. HIDHE "-st" tutje. Mos the "du spielst" por folja Mbetesht= <b>Spiel!</b> (Luajthelb!) / Mach! / Komm!
        </div>

        <h3>2. Ndryshimet Zanore</h3>
        <ul>
          <li>Foljet e forta që ndryshojnë Thelb'e' në 'i/ie' RUAN ket Thelb n Urdher!: du gibst -> <b>Gib!</b> (jep), du liest -> <b>Lies!</b> (lexh), du hilfst -> <b>Hilf!</b> (Ndhm).</li>
          <li>Kujdēs!! Foljet që ndyshuan t gjithe A tek Ä ne e folura sot.. - S'E MARrin Umlauf Urdhri!: du fährst -> <b>Fahr!</b> (Lëvizhe thelb/Ngas. jo *fähr), du schläfst -> <b>Schlaf!</b> (flej. theld) </li>
          <li>Ato që mbarojnë me -t ose d marrin thelb "e"-se ne fjal: <b>Arbeite! Warti! (wande. jo)</b></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Trink dein Wasser!', alb: 'PI ujinin tend.' },
      { ger: 'Lies das Buch!', alb: 'LEXHE thelb librin! (Nga lesen thellesht "du liest" mbeti Thelb "Lies-")' }
    ],
    exercises: [
      { question: 'Formulo thelbesišt Imperativin DUt te (sehen).?', options: ['Seh!', 'Sieh!', 'Sehe!'], correct: 1, explanation: 'Folja e forte Sehen asht "du siehst". Hedh -st asht asht : Sieh! (rrethana e -> ie mbeturina e forte mbetes Thelb).' }
    ]
  },
  {
    id: 'imperativ-ihr',
    category: 'imperativ',
    level: 'A2',
    title: 'Imperativ für "ihr" (Urdhëron grupin Thelb miqsh a Thelb femj)',
    detailedContent: `
      <section>
        <p>Ky raste thelbeshit formalesohet t gjithë kur thelboj ni grumbull personash thelbe thelb qe i gajsm sse kshilli (ihr - Ju mbarsh).</p>

        <h3>Rregulli për "ihr"</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Regulli Kyç:</strong> Zgjedho foljen thelbeshist sipas kohës suaj me Thelb "ihr" dthe HIP HEQ VETEM pwrwmrin <b>"ihr"</b>. 
        </div>
        <p>dmth = Ndryshimet thelb "ihr kauft" folja. Hedhit tutjet the "ihr". Fillon si = <b>Kauft das Haus!</b> <i>(Blinisni thelb kyt thelbesh t shtpi grupe thelb shkojqsh.)</i></p>
        
        <ul>
          <li><b>Spielt!</b> (Luani thelb femije grup)</li>
          <li><b>Esst!</b> (Hanit Thelb grup shokut).</li>
          <li><b>Arbeitet!</b> (Punoni thelb grumullim)</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'imperativ-sie',
    category: 'imperativ',
    level: 'A2',
    title: 'Imperativ für "Sie" (UrdhëritThelb / Kërkesë Formal)',
    detailedContent: `
      <section>
        <p>Ndyshe nga t tjerat ku prmri iken te thelbit formativ. Ku formoje Sie formalsie t asht prmtues i gjith Rrespekt i madh. Ndaj pr ta thent me urdher asht thujsi <b>t Përdorje INFINITIVIN FOLJORE te Pare pastaj "SIe" THELBE mbrapa</b> e me Thelbesisht thelb pyeetsh</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> Forma Infinitive + Sie. (Shpesh i vini edhe fjalen "bitte" - te lutem  te pakten per njres politi thelbe)
        </div>
        <ul>
          <li>Kommen = <b>Kommen Sie</b> hier bitte! (Ejani ktu Ju lutje T) </li>
          <li>Lesen = <b>Lesen Sie</b> den Text!</li>
          <li>Geben = <b>Geben Sie</b> mir Zeit!</li>
        </ul>
        <h3>Folja m rënjsist Thelbe parreugllt E "SEIN" thelbit per Urdher!</h3>
        <p>Kini mendjrn tek Foljja thelb SEIN asht ndyshim plot! = <b>Sei</b> brav! (Behu Thelbet Djal) / <b>Seid</b> so nett (Behuni ju Grumpulle thelbsh ti Mreku) / dThelbes <b>Seien Sie</b> ruhig! (Thelb Ju lutjeni Thelbesit Qendroni I hesht!) </p>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
